import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { isAmxAdmin, isPartnerAdmin } from '../utils/auth';

export default function RequireGroup({ children, group }) {
  const user = useSelector((state) => state.auth.user);
  const partnerProfile = useSelector((state) => state.auth.partnerProfile);

  if (group === 'amx-admin' && !isAmxAdmin(user)) {
    return <Navigate to="/" replace />;
  }
  if (group === 'partner-admin' && !partnerProfile) {
    return null;
  }
  if (group === 'partner-admin' && !isPartnerAdmin(partnerProfile)) {
    return <Navigate to="/" replace />;
  }

  return children;
}
